import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-200/70 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-semibold text-foreground-900 whitespace-nowrap">
              她之间
            </Link>
            <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
              探索女女情感世界，呈现女性之间真实、细腻的情感故事与生活体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">文章分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                联系我们
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                常见问题
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">友情链接</h4>
            <div className="flex flex-col gap-2">
              <a href="#" rel="nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">同语</a>
              <a href="#" rel="nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">彩虹法律热线</a>
              <a href="#" rel="nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">北京同志中心</a>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 她之间. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}